import { AllEvents, DataLayerEventName } from '@news-mono/web-common'
import React from 'react'
import { ElectionFilter } from '../components'
import { ElectionSearchInput } from '../components/ElectionSearch'
import { TheSeatsDivider } from '../TheSeatsWidget/TheSeatsWidget.styled'
import { ElectionFilterContext } from '../../../contexts'
import {
    SidebarAccordionContainer,
    SidebarFilterContainer,
    SidebarFilterWrapper,
    SidebarInputContainer,
} from './TNElectionSidebarFilter.styled'
import { NightlyButton } from '../../../buttons/NightlyButton/NightlyButton'
import { Accordion } from '../../../navigation/TNAccordion/Accordion'

export interface TNElectionSidebarFilterProps {
    onEvent: (event: AllEvents) => void
    topMarginOverride?: number
    isSearchEnabled?: boolean
    isAlphabeticalEnabled?: boolean
    isStateFilterEnabled?: boolean
}

export const TNElectionSidebarFilter = ({
    onEvent,
    isStateFilterEnabled = true,
    isSearchEnabled = false,
    isAlphabeticalEnabled = false,
    topMarginOverride,
}: TNElectionSidebarFilterProps): JSX.Element => {
    const { search, sort, state, submitSearch } = React.useContext(
        ElectionFilterContext,
    )

    // If no filters are enabled, don't render the sidebar at all
    if (!isSearchEnabled && !isAlphabeticalEnabled && !isStateFilterEnabled) {
        return <></>
    }

    const handleResetFilters = () => {
        search.setValue(search.initialValue)
        sort.setValue(sort.initialValue)
        state.setValue(state.initialValue)
        submitSearch(search.initialValue)
    }

    const handleSubmitSearch = () => {
        submitSearch(search.value)
    }

    const appliedFiltersCount =
        (state.value !== state.initialValue ? 1 : 0) +
        (sort.value !== sort.initialValue ? 1 : 0)

    const accordionHeaderText =
        appliedFiltersCount > 0
            ? `Filter and sort (${appliedFiltersCount})`
            : 'Filter and sort'

    return (
        <SidebarFilterContainer topMarginOverride={topMarginOverride}>
            {isSearchEnabled && (
                <SidebarInputContainer>
                    <ElectionSearchInput
                        onEvent={onEvent}
                        electionFilter={search}
                    />
                    <NightlyButton
                        variant={'default'}
                        action={{
                            type: 'button',
                            onClick: handleSubmitSearch,
                        }}
                        color="primary"
                        fill="filled"
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                        text={'Search'}
                    />
                </SidebarInputContainer>
            )}
            {/* This Wrapper only appears on Desktop*/}
            <SidebarFilterWrapper>
                {isAlphabeticalEnabled && (
                    <ElectionFilter
                        headingText="Sort by"
                        dataLayerEventOriginator="ElectionSort"
                        onEvent={onEvent}
                        dataLayerEventName={DataLayerEventName.searchFilter}
                        electionFilter={sort}
                    />
                )}
                {isStateFilterEnabled && (
                    <ElectionFilter
                        headingText="State"
                        dataLayerEventOriginator="ElectionStateFilter"
                        onEvent={onEvent}
                        dataLayerEventName={DataLayerEventName.searchFilter}
                        electionFilter={state}
                    />
                )}
                <NightlyButton
                    variant={'default'}
                    isDisabled={
                        state.value === state.initialValue &&
                        sort.value === sort.initialValue &&
                        search.value === search.initialValue
                    }
                    action={{
                        type: 'button',
                        onClick: handleResetFilters,
                    }}
                    color="primary"
                    fill="filled"
                    layout={{
                        shouldGrow: true,
                        alignSelf: 'stretch',
                    }}
                    text={'Reset filters'}
                />
            </SidebarFilterWrapper>
            {/* This Accordion only appears on Mobile */}
            <SidebarAccordionContainer>
                <Accordion
                    headerText={accordionHeaderText}
                    contentWrapperClassName={'electorate-sidebar-filter'}
                >
                    {isAlphabeticalEnabled && (
                        <ElectionFilter
                            headingText="Sort by"
                            dataLayerEventOriginator="ElectionSort"
                            onEvent={onEvent}
                            dataLayerEventName={DataLayerEventName.searchFilter}
                            electionFilter={sort}
                        />
                    )}
                    {isStateFilterEnabled && (
                        <ElectionFilter
                            headingText="State"
                            dataLayerEventOriginator="ElectionStateFilter"
                            onEvent={onEvent}
                            dataLayerEventName={DataLayerEventName.searchFilter}
                            electionFilter={state}
                        />
                    )}
                    <NightlyButton
                        variant={'default'}
                        isDisabled={
                            state.value === state.initialValue &&
                            sort.value === sort.initialValue &&
                            search.value === search.initialValue
                        }
                        action={{
                            type: 'button',
                            onClick: handleResetFilters,
                        }}
                        color="primary"
                        fill="filled"
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                        text={'Reset filters'}
                    />
                </Accordion>
            </SidebarAccordionContainer>

            <TheSeatsDivider />
        </SidebarFilterContainer>
    )
}
